export default {"src":"/_next/static/media/osuuspankki.9f60731e.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};